import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getTroubleshootingFilterConfig = ({ filters }: { filters: any }) => {
	return [
		filters[FILTER_CONFIG_NAMES.LOCATION],
		filters[FILTER_CONFIG_NAMES.PROBLEM_TYPE],
		filters[FILTER_CONFIG_NAMES.PRIORITY],
	].filter(Boolean);
};
